<ng-container *transloco="let t">
  <div class="comment-card" [class.selected]="isSelected" #cardElement>
    @if (comment) {
      <div class="comment-header">
        <span
          class="title"
          [class.margin-bottom]="comment?.title && (comment.summary || comment.content)"
        >
          {{ comment?.title }}
        </span>
        <div class="comment-indicators">
          @for (ind of indicators; track ind) {
            @if (ind.visible) {
              <xi-icon-button
                [color]="ind.color"
                [icon]="ind.icon"
                [tooltip]="{ text: ind.tooltipText }"
                [disabled]="ind.disabled"
                (onClick)="ind.clickHandler && ind.clickHandler()"
              >
              </xi-icon-button>
            }
          }
          @if (!(authService.isReadOnly || authService.isExecutive)) {
            <div [matMenuTriggerFor]="menuTrigger">
              <xi-icon-button
                icon="kabob"
                color="CX"
                [hasAnimation]="false"
                (onClick)="$event.stopPropagation()"
              >
              </xi-icon-button>
            </div>
          }
        </div>
      </div>
      @if (comment?.summary || comment?.content) {
        <div class="comment-text-content">
          {{ comment.summary || comment.content }}
        </div>
      }
      <div class="comment-footer">
        <span class="creation-info">
          {{
            t('comment-card.creation-info', {
              date: (comment?.createdAt | lexDate: 'xiShort'),
              createdBy: createdBy,
            })
          }}
        </span>
        <span class="details-link" (click)="openComment()">
          {{ t('comment-card.open') }}
        </span>
      </div>
    }
  </div>

  <mat-menu class="menu-with-xi-icons" #menuTrigger>
    <button mat-menu-item [disabled]="isDashboardLocked" (click)="deleteComment()">
      <xi-icon icon="trash" color="CX"></xi-icon>
      <div>
        {{ t('comment-card.delete-comment') }}
      </div>
    </button>
  </mat-menu>
</ng-container>
